<template>
    <li class="list-item-widget flex-column round-sm pad-h-1 pad-v-d5 mrg-b-d5 bg-color-neutral pad-v-1-s">
        <a class="li-w-link ellipsis" :href="itemLink" target="_blank">
            <b class="color-green mrg-r-1">·</b>{{itemTitle}}
        </a>
    </li>
</template>

<script>
    export default {
        name: "list-item-widget",
        props: ["itemTitle", "itemLink"]
    }
</script>

<style scoped>
    .list-item-widget:hover {
        background-color: #111;
    }
    .list-item-widget:hover .li-w-link {
        color: #ffcc00;
    }
</style>


// WEBPACK FOOTER //
// src/components/list-item-widget.vue